/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CheckDuplicatePayload,
  DuplicateCheckResult,
  FileAttachmentDto,
  FindByReferenceIdAndReferenceTypeParams,
  SimpleFileDto,
  UploadParams,
  UploadPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAttachmentController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-attachment-controller
   * @name Upload
   * @request POST:/api/v1/attachments
   */
  upload = (query: UploadParams, data: UploadPayload, params: RequestParams = {}) =>
    this.http.request<FileAttachmentDto, any>({
      path: `/v1/attachments`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadPath = '/v1/attachments'
  static uploadMethod = 'POST'
  /**
   * No description
   *
   * @tags api-attachment-controller
   * @name CheckDuplicate
   * @request POST:/api/v1/attachments/duplicate
   */
  checkDuplicate = (data: CheckDuplicatePayload, params: RequestParams = {}) =>
    this.http.request<DuplicateCheckResult, any>({
      path: `/v1/attachments/duplicate`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static checkDuplicatePath = '/v1/attachments/duplicate'
  static checkDuplicateMethod = 'POST'
  /**
   * No description
   *
   * @tags api-attachment-controller
   * @name FindByFileId
   * @request GET:/api/v1/attachments/{id}
   */
  findByFileId = (id: string, params: RequestParams = {}) =>
    this.http.request<FileAttachmentDto, any>({
      path: `/v1/attachments/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findByFileIdPath = '/v1/attachments/${id}'
  static findByFileIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-attachment-controller
   * @name Delete
   * @request DELETE:/api/v1/attachments/{id}
   */
  delete = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/attachments/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deletePath = '/v1/attachments/${id}'
  static deleteMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-attachment-controller
   * @name Download
   * @request GET:/api/v1/attachments/{id}/download
   */
  download = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/attachments/${id}/download`,
      method: 'GET',
      ...params,
    })

  static downloadPath = '/v1/attachments/${id}/download'
  static downloadMethod = 'GET'
  /**
   * No description
   *
   * @tags api-attachment-controller
   * @name GetAttachedFiles
   * @request GET:/api/v1/attachments/referenceType/{referenceType}/referenceId/{referenceId}
   */
  getAttachedFiles = (
    referenceId: string,
    referenceType:
      | 'ADD_ATTACHMENT'
      | 'RECEIPT'
      | 'SUBSCRIPTION_MIGRATION'
      | 'IMPORT_CARDS_CSV_SOURCE'
      | 'IMPORT_CARDS_CSV_EXEC_LOG'
      | 'INVOICE'
      | 'PURCHASE_REQUEST'
      | 'CARD_TRANSACTION'
      | 'REIMBURSEMENT',
    params: RequestParams = {},
  ) =>
    this.http.request<SimpleFileDto[], any>({
      path: `/v1/attachments/referenceType/${referenceType}/referenceId/${referenceId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAttachedFilesPath =
    '/v1/attachments/referenceType/${referenceType}/referenceId/${referenceId}'
  static getAttachedFilesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-attachment-controller
   * @name FindByReferenceIdAndReferenceType
   * @request GET:/api/v1/attachments/list
   */
  findByReferenceIdAndReferenceType = (
    query: FindByReferenceIdAndReferenceTypeParams,
    params: RequestParams = {},
  ) =>
    this.http.request<FileAttachmentDto[], any>({
      path: `/v1/attachments/list`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findByReferenceIdAndReferenceTypePath = '/v1/attachments/list'
  static findByReferenceIdAndReferenceTypeMethod = 'GET'
}
